import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, UUID, COLLECTION } from '@/plugins/sdk/fields'
import Index from '@/plugins/sdk/resources/RateSurcharge/Index'
import RateSurcharge from '@/plugins/sdk/resources/RateSurcharge'

export default class extends Resource {
  static name = 'ratesurcharge_group'

  static get fields () {
    return {
      id: new UUID(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      indices: new COLLECTION(Index),
      rate_surcharge: new COLLECTION(RateSurcharge)
    }
  }
}
